import { createContext, useCallback, useContext, useRef, useState } from 'react';
import { AppContainerContextValue, ContentMeta, SIDEBAR_MODE, SidebarMode } from './types';

const AppContainerContext = createContext<AppContainerContextValue | undefined>(undefined);

type Props = {
  children: React.ReactNode;
};

export function AppContainerProvider({ children }: Props) {
  const sidebarContentRef = useRef<React.ReactNode | null>(null);
  const [contentMeta, setContentMeta] = useState<ContentMeta | null>(null);
  const [mode, setMode] = useState<SidebarMode>('standard');

  const setSidebarContent = useCallback((content: React.ReactNode | null) => {
    sidebarContentRef.current = content;
  }, []);

  const toggleMode = () => {
    setMode(prev =>
      prev === SIDEBAR_MODE.standard ? SIDEBAR_MODE.expanded : SIDEBAR_MODE.standard,
    );
  };

  return (
    <AppContainerContext.Provider
      value={{
        sidebarContent: sidebarContentRef.current,
        setSidebarContent,
        contentMeta,
        setContentMeta,
        mode,
        setMode,
        toggleMode,
      }}
    >
      {children}
    </AppContainerContext.Provider>
  );
}

export function useAppContainerContext() {
  const context = useContext(AppContainerContext);
  if (context === undefined) {
    throw new Error('useAppContainerContext must be used within AppContainerProvider');
  }
  return context;
}
